import * as Sentry from "@sentry/vue";
import {
  CaptureConsole,
  ReportingObserver,
  ExtraErrorData
} from "@sentry/integrations";

import Vue from "vue";

import axios from "axios";

const getSentryDsn = async () => {
  const sentryDsn = JSON.parse(localStorage.getItem("sentrydns") || "{}");
  const now = new Date().toLocaleDateString("pt-BR");

  if (Object.keys(sentryDsn).length) {
    if (sentryDsn.date === now) return sentryDsn.data;
  }

  const results = await axios({
    url: "sentry-front-url/",
    method: "GET"
  }).then(response => {
    return { kind: "ok", data: response.data };
  });

  if (results.kind === "ok") {
    localStorage.setItem(
      "sentrydns",
      JSON.stringify({
        date: now,
        data: results.data.sentry_frontend_url
      })
    );

    const dsn: string = await getSentryDsn();
    return dsn;
  }
};

export default async () => {
  const dsn = await getSentryDsn();

  Sentry.init({
    Vue,
    dsn,
    autoSessionTracking: true,
    integrations: [
      new CaptureConsole({
        levels: ["error"]
      }),
      new Sentry.Replay({
        maskAllText: false,
        blockAllMedia: true
      }),
      new ReportingObserver(),
      new ExtraErrorData()
    ],

    environment: process.env.NODE_ENV,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    tracesSampleRate: 1.0
  });
};
